// extracted by mini-css-extract-plugin
module.exports = {"component":"progress-bar_component__MC_j_","track":"progress-bar_track__a6G6R","fill":"progress-bar_fill__U_rxt","label":"progress-bar_label__eGRmp"};